export default __webpack_public_path__ + "static/scholar-0b4c36e80a7425afa9d9e5627def8882.png";